export enum TypeKeys {
    ON_TAB_CHANGE = 'workflowOverlay/ON_TAB_CHANGE',
    CONFIRM_OWN_GRADING = 'workflowOverlay/CONFIRM_OWN_GRADING',
    CONFIRM_FINAL_GRADES = 'workflowOverlay/CONFIRM_FINAL_GRADES',
    TOGGLE_PROCESSING = 'workflowOverlay/TOGGLE_PROCESSING',
    SAVE_CANDIDATES_MISSING_GRADE_COUNT = 'workflowOverlay/SAVE_CANDIDATES_MISSING_GRADE_COUNT',
    WORKFLOW_OVERLAY_LOADED = 'workflowOverlay/WORKFLOW_OVERLAY_LOADED',
    ON_CANDIDATE_SHARE = 'workflowOverlay/ON_CANDIDATE_SHARE',
    ON_CANDIDATE_ALIGN = 'workflowOverlay/ON_CANDIDATE_ALIGN',
    ON_CANDIDATE_CONFIRM = 'workflowOverlay/ON_CANDIDATE_CONFIRM',
    CANDIDATE_SHARED = 'workflowOverlay/CANDIDATE_SHARED',
    CANDIDATE_CONFIRMED = 'workflowOverlay/CANDIDATE_CONFIRMED',
    CANDIDATE_UNSHARED = 'workflowOverlay/CANDIDATE_UNSHARED',
    CANDIDATE_UNCONFIRMED = 'workflowOverlay/CANDIDATE_UNCONFIRMED',
    ON_CANDIDATE_UNAPPROVE = 'workflowOverlay/ON_CANDIDATE_UNAPPROVE',
    ON_CANDIDATE_UNCONFIRM = 'workflowOverlay/ON_CANDIDATE_UNCONFIRM',

    APPROVE_ON_BEHALF = 'workflowOverlay/APPROVE_ON_BEHALF',
    CONFIRM_ON_BEHALF = 'workflowOverlay/CONFIRM_ON_BEHALF',
    UNNAPROVE_ON_BEHALF = 'workflowOverlay/UNNAPROVE_ON_BEHALF',
    UNCONFIRM_ON_BEHALF = 'workflowOverlay/UNCONFIRM_ON_BEHALF',

    ON_APPROVE_ON_BEHALF = 'workflowOverlay/ON_APPROVE_ON_BEHALF',
    ON_CONFIRM_ON_BEHALF = 'workflowOverlay/ON_CONFIRM_ON_BEHALF',
    ON_UNNAPROVE_ON_BEHALF = 'workflowOverlay/ON_UNNAPROVE_ON_BEHALF',
    ON_UNCONFIRM_ON_BEHALF = 'workflowOverlay/ON_UNCONFIRM_ON_BEHALF',

    REOPEN_MARKING = 'workflowOverlay/REOPEN_MARKING',
    ON_REOPEN_MARKING = 'workflowOverlay/ON_REOPEN_MARKING'
}

export interface CandidateShared {
    type: TypeKeys.CANDIDATE_SHARED;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface CandidateConfirmed {
    type: TypeKeys.CANDIDATE_CONFIRMED;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface CandidateUnshared {
    type: TypeKeys.CANDIDATE_UNSHARED;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface CandidateUnconfirmed {
    type: TypeKeys.CANDIDATE_UNCONFIRMED;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnCandidateShare {
    type: TypeKeys.ON_CANDIDATE_SHARE;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnCandidateUnapprove {
    type: TypeKeys.ON_CANDIDATE_UNAPPROVE;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnCandidateAlign {
    type: TypeKeys.ON_CANDIDATE_ALIGN;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnCandidateConfirm {
    type: TypeKeys.ON_CANDIDATE_CONFIRM;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnCandidateUnconfirm {
    type: TypeKeys.ON_CANDIDATE_UNCONFIRM;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface WorkflowOverlayLoadedAction {
    type: TypeKeys.WORKFLOW_OVERLAY_LOADED;
    featureId: string;
}

export interface OnTabChangeAction {
    type: TypeKeys.ON_TAB_CHANGE;
    activeIndex: number;
    featureId: string;
}

export interface ConfirmGradingAction {
    type: TypeKeys.CONFIRM_OWN_GRADING | TypeKeys.CONFIRM_FINAL_GRADES;
    approve: boolean;
    onBehalfOfGraders: boolean;
    featureId: string;
}

export interface ToggleProcessingAction {
    featureId: string;
    type: TypeKeys.TOGGLE_PROCESSING;
}

export interface SaveNumberOfCandidatesWithMissingGrade {
    featureId: string;
    count: number;
    type: TypeKeys.SAVE_CANDIDATES_MISSING_GRADE_COUNT;
}

export interface ApproveOnBehalf {
    type: TypeKeys.APPROVE_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnApproveOnBehalf {
    type: TypeKeys.ON_APPROVE_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface ConfirmOnBehalf {
    type: TypeKeys.CONFIRM_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnConfirmOnBehalf {
    type: TypeKeys.ON_CONFIRM_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface UnnaproveOnBehalf {
    type: TypeKeys.UNNAPROVE_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnUnnaproveOnBehalf {
    type: TypeKeys.ON_UNNAPROVE_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface UnconfirmOnBehalf {
    type: TypeKeys.UNCONFIRM_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnUnconfirmOnBehalf {
    type: TypeKeys.ON_UNCONFIRM_ON_BEHALF;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface ReopenMarking {
    type: TypeKeys.REOPEN_MARKING;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export interface OnReopenMarking {
    type: TypeKeys.ON_REOPEN_MARKING;
    assessmentRunId: number;
    partyId: number;
    featureId: string;
}

export type ActionTypes =
    OnTabChangeAction
    | ConfirmGradingAction
    | ToggleProcessingAction
    | SaveNumberOfCandidatesWithMissingGrade
    | WorkflowOverlayLoadedAction
    | OnCandidateShare
    | OnCandidateAlign
    | OnCandidateConfirm
    | CandidateConfirmed
    | CandidateShared
    | CandidateUnshared
    | CandidateUnconfirmed
    | ApproveOnBehalf
    | UnnaproveOnBehalf
    | ConfirmOnBehalf
    | UnconfirmOnBehalf
    | OnApproveOnBehalf
    | OnConfirmOnBehalf
    | OnUnnaproveOnBehalf
    | OnUnconfirmOnBehalf
    | ReopenMarking
    | OnReopenMarking;

export const candidateShared = (featureId: string, assessmentRunId: number, partyId: number): CandidateShared => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.CANDIDATE_SHARED,
});

export const candidateConfirmed = (featureId: string, assessmentRunId: number, partyId: number): CandidateConfirmed => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.CANDIDATE_CONFIRMED,
});

export const candidateUnshared = (featureId: string, assessmentRunId: number, partyId: number): CandidateUnshared => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.CANDIDATE_UNSHARED,
});

export const candidateUnconfirmed = (featureId: string, assessmentRunId: number, partyId: number): CandidateUnconfirmed => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.CANDIDATE_UNCONFIRMED,
});

export const onCandidateShare = (featureId: string, assessmentRunId: number, partyId: number): OnCandidateShare => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CANDIDATE_SHARE,
});

export const onCandidateUnapprove = (featureId: string, assessmentRunId: number, partyId: number): OnCandidateUnapprove => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CANDIDATE_UNAPPROVE,
});


export const onCandidateAlign = (featureId: string, assessmentRunId: number, partyId: number): OnCandidateAlign => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CANDIDATE_ALIGN,
});

export const onCandidateConfirm = (featureId: string, assessmentRunId: number, partyId: number): OnCandidateConfirm => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CANDIDATE_CONFIRM,
});

export const onCandidateUnconfirm = (featureId: string, assessmentRunId: number, partyId: number): OnCandidateUnconfirm => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CANDIDATE_UNCONFIRM,
});

export const approveOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): ApproveOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.APPROVE_ON_BEHALF,
});

export const onApproveOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): OnApproveOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_APPROVE_ON_BEHALF,
});

export const confirmOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): ConfirmOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.CONFIRM_ON_BEHALF,
});

export const onConfirmOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): OnConfirmOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_CONFIRM_ON_BEHALF,
});

export const unnaproveOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): UnnaproveOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.UNNAPROVE_ON_BEHALF,
});

export const onUnnaproveOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): OnUnnaproveOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_UNNAPROVE_ON_BEHALF,
});

export const unconfirmOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): UnconfirmOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.UNCONFIRM_ON_BEHALF,
});

export const onUnconfirmOnBehalf = (featureId: string, assessmentRunId: number, partyId: number): OnUnconfirmOnBehalf => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_UNCONFIRM_ON_BEHALF,
});

export const reopenMarking = (featureId: string, assessmentRunId: number, partyId: number): ReopenMarking => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.REOPEN_MARKING,
});

export const onReopenMarking = (featureId: string, assessmentRunId: number, partyId: number): OnReopenMarking => ({
    featureId,
    assessmentRunId,
    partyId,
    type: TypeKeys.ON_REOPEN_MARKING,
});

export const saveNumberOfCandidatesWithMissingGrade = (featureId: string, count: number): SaveNumberOfCandidatesWithMissingGrade => ({
    featureId,
    count,
    type: TypeKeys.SAVE_CANDIDATES_MISSING_GRADE_COUNT,
});

export const workflowOverlayLoaded = (featureId: string): WorkflowOverlayLoadedAction => ({
    featureId,
    type: TypeKeys.WORKFLOW_OVERLAY_LOADED,
});

export const onTabChange = (featureId: string, activeIndex: number): OnTabChangeAction => ({
    featureId,
    activeIndex,
    type: TypeKeys.ON_TAB_CHANGE,
});

export const confirmGrading = (
    featureId: string,
    approve: boolean,
    onBehalfOfGraders: boolean,
    type: TypeKeys.CONFIRM_OWN_GRADING | TypeKeys.CONFIRM_FINAL_GRADES,
): ConfirmGradingAction => ({
    featureId,
    approve,
    onBehalfOfGraders,
    type,
});

export const confirmOwnGrading = (featureId: string, approve: boolean, onBehalfOfGraders: boolean) => {
    return confirmGrading(featureId, approve, onBehalfOfGraders, TypeKeys.CONFIRM_OWN_GRADING);
};

export const confirmFinalGrading = (featureId: string, approve: boolean, onBehalfOfGraders: boolean) => {
    return confirmGrading(featureId, approve, onBehalfOfGraders, TypeKeys.CONFIRM_FINAL_GRADES);
};

export const toggleProcessing = (featureId: string): ToggleProcessingAction => ({
    featureId,
    type: TypeKeys.TOGGLE_PROCESSING,
});
